module.exports = new __parcel__URL__("other.80576dc7.svg").toString();